import React from "react";

import CommerceTabs from "./components/CommerceTabs";
import Wrapper from "./styles/Wrapper.style";

function Commerce(props) {
  return (
    <Wrapper>
      <h3 className="title">Choose a license:</h3>
      <CommerceTabs {...props} />
    </Wrapper>
  );
}

export default Commerce;
